module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rémi Brague, Lydia G. Cochrane\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("Rémi Brague")]), _vm._v(" is professor of philosophy at the Université Paris I Panthéon-Sorbonne and at the University of Munich. He is the author of nine other books, including "), _c('I', [_vm._v("The Law of God")]), _vm._v(" and "), _c('I', [_vm._v("The Wisdom of the World")]), _vm._v(", both published by the University of Chicago Press. "), _c('B', [_vm._v("Lydia")]), _c('B', [_vm._v("G. Cochrane")]), _vm._v(" has translated numerous books for the University of Chicago Press.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/LjN9i2/tc-custom/9780226797212.jpg?1724816537277",
      "alt": "This image is the cover for the book Legend of the Middle Ages"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Legend of the Middle Ages\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This volume presents a penetrating interview and sixteen essays that explore key intersections of medieval religion and philosophy. With characteristic erudition and insight, RémiBrague focuses less on individual Christian, Jewish, and Muslim thinkers than on their relationships with one another. Their disparate philosophical worlds, Brague shows, were grounded in different models of revelation that engendered divergent interpretations of the ancient Greek sources they held in common. So, despite striking similarities in their solutions for the philosophical problems they all faced, intellectuals in each theological tradition often viewed the others’ ideas with skepticism, if not disdain. Brague’s portrayal of this misunderstood age brings to life not only its philosophical and theological nuances, but also lessons for our own time.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The University of Chicago Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0